import { render, staticRenderFns } from "./addSupplierDia.vue?vue&type=template&id=19004608"
import script from "./addSupplierDia.vue?vue&type=script&lang=js"
export * from "./addSupplierDia.vue?vue&type=script&lang=js"
import style0 from "./addSupplierDia.vue?vue&type=style&index=0&id=19004608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports